import dayjs from "dayjs"

class VisitServiceOrder {
    constructor(
        id,
        serviceOrderID,
        serviceOrderReportTemplateID,
        technicianID,
        reportData,
        status,
        notesFromAdmin,
        createdDate,
        updatedDate,
        submittedDate,
        approvedDate,
        formSchema,
        images,
        startedDate,
    ) {
        this.id = id
        this.serviceOrderID = serviceOrderID
        this.serviceOrderReportTemplateID = serviceOrderReportTemplateID
        this.technicianID = technicianID
        this.reportData = reportData
        this.status = status
        this.notesFromAdmin = notesFromAdmin
        this.createdDate = createdDate
        this.updatedDate = updatedDate
        this.submittedDate = submittedDate
        this.approvedDate = approvedDate
        this.formSchema = formSchema
        this.images = images,
        this.startedDate = startedDate
    }
}

export const VisitServiceOrderDefault = () => {
    const visitServiceOrder = {
        id: 0,
        serviceOrderID: 0,
        serviceOrderReportTemplateID: 0,
        technicianID: 0,
        reportData: [],
        status: "",
        notesFromAdmin: "",
        createdDate: "",
        updatedDate: "",
        submittedDate: "",
        approvedDate: "",
        formSchema: {},
        images: [],
        startedDate: dayjs().toISOString()
    }

    return visitServiceOrder
}

export default VisitServiceOrder